import React, { useState, useRef, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import Transition from "../../utils/Transition";
import UserAvatar from "../../images/user-avatar-32.png";

function UserMenu(props) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const history = useHistory();

  const trigger = useRef(null);
  const dropdown = useRef(null);

  const [userToken, setUserToken] = useState(null);

  const getJWT = () => {
    return (Headers["authorization"] = localStorage.getItem("jwt_token"));
  };

  const isLoggedIn = () => {
    let is_logged_in =
      getJWT() !== null &&
      getJWT() !== "null" &&
      getJWT() !== undefined &&
      getJWT() !== "undefined";
    return is_logged_in;
  };

  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (isLoggedIn()) {
        if (
          !dropdownOpen ||
          dropdown.current.contains(target) ||
          trigger.current.contains(target)
        )
          return;
        setDropdownOpen(false);
      }
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });

  return (
    <div className="relative inline-flex">
      <button
        ref={trigger}
        className="inline-flex justify-center items-center group"
        aria-haspopup="true"
        onClick={() => setDropdownOpen(!dropdownOpen)}
        aria-expanded={dropdownOpen}
      >
        <img
          className="w-8 h-8 rounded-full"
          src={UserAvatar}
          width="32"
          height="32"
          alt="User"
        />
        <div className="flex items-center truncate">
          <span className="truncate ml-2 text-sm font-medium group-hover:text-gray-800">
            DG Enterprises
          </span>
          <svg
            className="w-3 h-3 flex-shrink-0 ml-1 fill-current text-gray-400"
            viewBox="0 0 12 12"
          >
            <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
          </svg>
        </div>
      </button>

      <Transition
        className="origin-top-right z-10 absolute top-full right-0 min-w-44 bg-white border border-gray-200 py-1.5 rounded shadow-lg overflow-hidden mt-1"
        show={dropdownOpen}
        enter="transition ease-out duration-200 transform"
        enterStart="opacity-0 -translate-y-2"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-out duration-200"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
      >
        <div
          ref={dropdown}
          onFocus={() => setDropdownOpen(true)}
          onBlur={() => setDropdownOpen(false)}
        >
          <div className="pt-0.5 pb-2 px-3 mb-1 border-b border-gray-200">
            <div className="font-medium text-gray-800">DG Enterprises</div>
            <div className="text-xs text-gray-500 italic">Administrator</div>
          </div>
          <ul>
            {props.userSetting &&
              props.userSetting.map((res, index) => {
                if (res.libelle === "Parametre") {
                  return (
                    res.fils &&
                    res.fils.map((res, index) => {
                      return (
                        <li key={index}>
                          <Link
                            className="font-medium text-sm text-indigo-500 hover:text-indigo-600 flex items-center py-1 px-3"
                            to={res.href}
                            onClick={() => setDropdownOpen(!dropdownOpen)}
                          >
                            {res.libelle}
                          </Link>
                        </li>
                      );
                    })
                  );
                }
              })}
            <hr className="w-px h-6 bg-gray-200 mx-3" />
            <li>
              <Link
                className="font-medium text-sm text-grey-500 hover:text-indigo-600 flex items-center py-1 px-3"
                to="/"
                onClick={() => {
                  setUserToken(null);
                  localStorage.setItem("jwt_token", null);
                  history.push("/login");
                }}
              >
                Déconnexion
              </Link>
            </li>
          </ul>
        </div>
      </Transition>
    </div>
  );
}

export default UserMenu;
